import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard, faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons';

function PaymentFailureModal(props) {

    return (
        <Modal isOpen={props.open} toggle={props.toggle}>
            <ModalHeader>
                Payment Unsuccessful
            </ModalHeader>
            <ModalBody>
                <div>
                    <p>Your payment was unsuccessful.</p>
                    <p>{props.message}</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="danr-red" onClick={props.toggle}><span>OK</span></Button>
            </ModalFooter>
        </Modal>
    );
}

export default PaymentFailureModal;